import { translatePath } from './helper/translatePath'
import { lastPoint } from './helper/lastPoint'
import { adapterHeadNutSlotWidth } from 'src/constants/parameters'

import defaultParameters from '../../defaultConfig'

//  when use positive Parameters,
//  every path could be found at the first quadrant of a cartesian coordinate system
//  ( mostly the longest Side directs to x = ∞
//
//  |y
//  |
//  |     ____
//  |______|  |______> path
//  |_________________________________ x

const pathA = (
  enclosureSize = 0,
  enclosureThickness = defaultParameters.enclosureThickness,
  adapterHeadCornerPositionWidth = defaultParameters.adapterHeadCornerPositionWidth,
  adapterHeadSlotWidth = adapterHeadNutSlotWidth,
  adapterProfileShift = defaultParameters.adapterProfileShift
) => {
  const result = [
    [0, 0],
    [adapterHeadCornerPositionWidth + adapterHeadSlotWidth + adapterProfileShift, 0],
    [adapterHeadCornerPositionWidth + adapterHeadSlotWidth + adapterProfileShift, enclosureThickness],
    [-adapterHeadSlotWidth / 2 + enclosureSize / 2 - enclosureThickness, enclosureThickness],
    [-adapterHeadSlotWidth / 2 + enclosureSize / 2 - enclosureThickness, 0],
    [enclosureSize / 2 - enclosureThickness, 0],
    [adapterHeadSlotWidth / 2 + enclosureSize / 2 - enclosureThickness, 0],
    [adapterHeadSlotWidth / 2 + enclosureSize / 2 - enclosureThickness, enclosureThickness],
    [
      -enclosureThickness -
        enclosureThickness -
        adapterHeadCornerPositionWidth -
        adapterHeadSlotWidth +
        enclosureSize -
        adapterProfileShift,
      enclosureThickness
    ],
    [
      -enclosureThickness -
        enclosureThickness -
        adapterHeadCornerPositionWidth -
        adapterHeadSlotWidth +
        enclosureSize -
        adapterProfileShift,
      0
    ],
    [-enclosureThickness - enclosureThickness + enclosureSize, 0]
  ]
  return result
}

const pathB = (
  enclosureSize = 0,
  enclosureThickness = defaultParameters.enclosureThickness,
  adapterHeadSlotWidth = adapterHeadNutSlotWidth,
  adapterHeadCornerPositionWidth = defaultParameters.adapterHeadCornerPositionWidth,
  adapterProfileShift = defaultParameters.adapterProfileShift
) => {
  return [
    [0, 0],
    [adapterHeadCornerPositionWidth + adapterHeadSlotWidth + adapterProfileShift, 0],
    [adapterHeadCornerPositionWidth + adapterHeadSlotWidth + adapterProfileShift, enclosureThickness],
    [
      -(2 * enclosureThickness) -
        adapterHeadCornerPositionWidth -
        adapterHeadSlotWidth +
        enclosureSize -
        adapterProfileShift,
      enclosureThickness
    ],
    [
      -(2 * enclosureThickness) -
        adapterHeadCornerPositionWidth -
        adapterHeadSlotWidth +
        enclosureSize -
        adapterProfileShift,
      0
    ],
    [-(2 * enclosureThickness) + enclosureSize, 0]
  ]
}

const pathC = (
  enclosureSize = 0,
  enclosureThickness = defaultParameters.enclosureThickness,
  adapterThickness1 = defaultParameters.adapterThickness1,
  adapterThickness2 = defaultParameters.adapterThickness2
) => {
  return [
    [0, 0],
    [enclosureThickness + adapterThickness1, 0],
    [enclosureThickness + adapterThickness1, enclosureThickness],
    [-enclosureThickness - adapterThickness1 + enclosureSize, enclosureThickness],
    [-enclosureThickness - adapterThickness1 + enclosureSize, 0],
    [enclosureSize, 0]
  ]
  return [
    [0, 0],
    [enclosureThickness + adapterThickness1 + adapterThickness2, 0],
    [enclosureThickness + adapterThickness1 + adapterThickness2, enclosureThickness],
    [-enclosureThickness - adapterThickness1 - adapterThickness2 + enclosureSize, enclosureThickness],
    [-enclosureThickness - adapterThickness1 - adapterThickness2 + enclosureSize, 0],
    [enclosureSize, 0]
  ]
}

const pathD = (
  enclosureSize,
  enclosureThickness,
  adapterHeadSlotWidth = adapterHeadNutSlotWidth,
  adapterHeadCornerPositionWidth
) => {
  const arr = [[0, 0]]
  const TB = translatePath(
    pathB(enclosureSize, enclosureThickness, adapterHeadSlotWidth, adapterHeadCornerPositionWidth),
    [enclosureThickness, 0]
  )
  return arr.concat(TB, [[lastPoint(TB)[0] + enclosureThickness, 0]])
}
export { pathA, pathB, pathC, pathD }
